/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryFormatEndpointRequest
 */
export interface TapeLibraryFormatEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryFormatEndpointRequest
     */
    barcode: string;
}

export function TapeLibraryFormatEndpointRequestFromJSON(json: any): TapeLibraryFormatEndpointRequest {
    return TapeLibraryFormatEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryFormatEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryFormatEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TapeLibraryFormatEndpointRequestToJSON(value?: TapeLibraryFormatEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
    };
}


